import React, { useCallback, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";

// import Header from "../../layouts/Header";
// import Footer from "../../layouts/Footer";
import "./dashboard.css";
import CitySelector from "./CitySelector";
import Category2 from "./category2";
import Articles from "./Articles";
import Cities from "./Cities";
import { ALL_SERVICE_SLUGS, getServiceBySlug } from "../../data/categoryConfig";
import { DASHBOARD_CATEGORIES } from "../../data/dashboardCategories";

// Import images
import banner1 from "../../assets/img/2323.png";
import b2b from "../../assets/img/Category_1.png";
import repairs from "../../assets/img/Category_2.png";
import realestate from "../../assets/img/Category_3.png";
import doctors from "../../assets/img/Category_4.png";
// import bannerVideo from "../../assets/img/banner_6.mp4";

import MobileCategoryGrid from "./MobileCategoryGrid";
// import RotatingCategoryText from "../dashboard/components/RotatingCategoryText";


// import HomeDiscoverySection from "./HomeDiscoverySection";


// Generate category keywords from centralized config
const CATEGORY_KEYWORDS = {}; ALL_SERVICE_SLUGS.forEach(slug => {
  const service = getServiceBySlug(slug); if (service) {
    const keywords = [service.name.toLowerCase(), service.name.toLowerCase().replace(/[^a-z0-9]/g, ''), slug.replace(/-/g, ' '), slug];
    // Add common variations
    if (slug.includes('beauty')) keywords.push('spa', 'salon', 'massage');
     if (slug.includes('service')) keywords.push('repair', 'fix', 'maintenance'); 
     if (slug.includes('hall')) keywords.push('venue', 'party', 'event');
      if (slug.includes('cater')) keywords.push('food', 'dining', 'party food');
       CATEGORY_KEYWORDS[slug] = keywords;

 

  }
});
      const EXTRA_MISSING_SLUGS = [
  "restaurants",
  "hotels",
  "wedding-planning",
  "event-organisers",
  "repair-services",
  "rent-hire",
];
EXTRA_MISSING_SLUGS.forEach(slug => {
  if (!CATEGORY_KEYWORDS[slug]) CATEGORY_KEYWORDS[slug] = [slug.replace(/-/g, " ")];
});
//change by gpt

// 🔍 Add-on: Expand keyword list for better search discoverability (no logic changes)
Object.keys(CATEGORY_KEYWORDS).forEach((slug) => {
  const extra = [];

  // General intent-based terms
  extra.push(
    "near me",
    "best",
    "top rated",
    "cheap",
    "affordable",
    "trusted",
    "service",
    "provider",
    "center"
  );

  // Category-specific enhancements
  if (slug.includes("beauty") || slug.includes("spa"))
    extra.push(
      "salon",
      "massage",
      "makeup",
      "haircut",
      "facial",
      "beautician",
      "parlour",
      "skincare",
      "nail art",
      "grooming",
      "bridal makeup",
      "unisex salon"
    );

  if (slug.includes("service") || slug.includes("repair"))
    extra.push(
      "ac repair",
      "technician",
      "maintenance",
      "home repair",
      "fix",
      "electrical",
      "mechanic",
      "fridge repair",
      "washing machine service",
      "bike repair",
      "home service"
    );

  if (slug.includes("wedding") || slug.includes("banquet") || slug.includes("event"))
    extra.push(
      "wedding planner",
      "banquet hall",
      "event management",
      "stage decoration",
      "party hall",
      "wedding decorator",
      "birthday planner",
      "photography",
      "event organiser"
    );

  if (slug.includes("education") || slug.includes("school") || slug.includes("coaching"))
    extra.push(
      "school",
      "nursery",
      "playgroup",
      "tuition",
      "academy",
      "training",
      "preschool",
      "college",
      "study",
      "learning center",
      "coaching class"
    );

  if (slug.includes("pg") || slug.includes("hostel") || slug.includes("rent"))
    extra.push(
      "girls pg",
      "boys pg",
      "room rent",
      "hostel near me",
      "co-living",
      "shared flat",
      "paying guest",
      "student pg",
      "affordable stay"
    );

  if (slug.includes("gym") || slug.includes("fitness"))
    extra.push(
      "yoga",
      "zumba",
      "workout",
      "fitness club",
      "bodybuilding",
      "personal trainer",
      "health club",
      "exercise"
    );

  if (slug.includes("astro") || slug.includes("vastu"))
    extra.push(
      "astrology",
      "vastu",
      "horoscope",
      "kundali",
      "puja",
      "pandit",
      "numerology",
      "consultant"
    );

  if (slug.includes("restaurant") || slug.includes("food") || slug.includes("cater"))
    extra.push(
      "food",
      "dining",
      "hotel",
      "catering",
      "party food",
      "veg restaurant",
      "non veg restaurant",
      "takeaway",
      "tiffin service"
    );

  if (slug.includes("saree") || slug.includes("fashion"))
    extra.push(
      "boutique",
      "lehenga",
      "ethnic wear",
      "dress",
      "designer",
      "clothing",
      "traditional wear"
    );

  // Merge and remove duplicates
  CATEGORY_KEYWORDS[slug] = [...new Set([...CATEGORY_KEYWORDS[slug], ...extra])];
});

// 🔍 Enrich CATEGORY_KEYWORDS with real business data for smarter search
import { BUSINESS_DATA } from "../../data/businesses"; // adjust path if needed

Object.keys(CATEGORY_KEYWORDS).forEach((slug) => {
  // Get all businesses linked to this category
  const relatedBusinesses = BUSINESS_DATA.filter((b) =>
    b.categories.includes(slug)
  );

  const extraKeywords = [];

  relatedBusinesses.forEach((biz) => {
    // Add business name tokens
    if (biz.name)
      extraKeywords.push(...biz.name.toLowerCase().split(/\s+/));

    // Add words from description
    if (biz.description)
      extraKeywords.push(...biz.description.toLowerCase().split(/\s+/));

    // Add features (if present)
    if (Array.isArray(biz.features))
      extraKeywords.push(...biz.features.map((f) => f.toLowerCase()));

    // Add some “intent” phrases for better discovery
    if (biz.name.toLowerCase().includes("cafe") || biz.name.toLowerCase().includes("restaurant"))
      extraKeywords.push("food", "dining", "lunch", "dinner", "breakfast", "eatery", "coffee");
    if (biz.name.toLowerCase().includes("event") || biz.name.toLowerCase().includes("decor"))
      extraKeywords.push("wedding", "party", "banquet", "planner", "organiser", "decorator");
  });

  // Merge business-based keywords with category-based ones
  CATEGORY_KEYWORDS[slug] = [
    ...new Set([...CATEGORY_KEYWORDS[slug], ...extraKeywords.filter(Boolean)]),
  ];
  
});



//end change by gpt


 const getCategoryLabel = (slug) => {
   const service = getServiceBySlug(slug); 
   return service ? service.name : slug.split("-").map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(" "); }; const CATEGORY_INTENT_INDEX = Object.entries(CATEGORY_KEYWORDS).map(([slug, keywords]) => ({ slug, slugLower: slug.toLowerCase(), label: getCategoryLabel(slug), keywords: keywords.map((kw) => ({ original: kw, lower: String(kw).toLowerCase(), })), })); const buildSuggestionsFromKeywords = (query) => { const q = (query || "").trim().toLowerCase(); if (!q) return []; const scored = []; for (const item of CATEGORY_INTENT_INDEX) { let bestScore = 0; let bestKeyword = ""; if (item.slugLower.includes(q) || q.includes(item.slugLower)) { bestScore = 1; } for (const kw of item.keywords) { let score = 0; if (kw.lower === q) score = 3; else if (kw.lower.startsWith(q) || q.startsWith(kw.lower)) score = 2; else if (kw.lower.includes(q) || q.includes(kw.lower)) score = 1; if (score > bestScore) { bestScore = score; bestKeyword = kw.original; } } if (bestScore > 0) { scored.push({ slug: item.slug, label: item.label, keyword: bestKeyword, score: bestScore, }); } } return scored.sort((a, b) => b.score - a.score || a.label.localeCompare(b.label)).slice(0, 6); }; const detectCategoryFromKeywords = (searchText) => { const text = String(searchText || "").toLowerCase(); for (const item of CATEGORY_INTENT_INDEX) { for (const kw of item.keywords) { if (text.includes(kw.lower)) { return item.slug; } } } return "popular"; };


const SERVICE_CARDS = [
  {
    img: b2b,
    alt: "B2B Quick Quotes",
    url: "/category/b2b-services",
    enabled: false,
  },
  {
    img: repairs,
    alt: "Repairs & Services",
    url: "/category/ac-service",
    enabled: true,
  },
  {
    img: realestate,
    alt: "Real Estate",
    url: "/category/real-estate",
    enabled: false,
  },
  {
    img: doctors,
    alt: "Doctors Online",
    url: "/category/physiotherapy",
    enabled: true,
  },
];

const SERVICE_CARDS_LOOP = [...SERVICE_CARDS, ...SERVICE_CARDS];

export default function Dashboard() {
  const [selectedCity, setSelectedCity] = useState("Vadodara");
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const history = useHistory();

  // Category keyword mapping for smart search
  const buildSuggestions = useCallback(buildSuggestionsFromKeywords, []);

  // Detect most relevant category based on search keywords
  const detectCategory = useCallback(detectCategoryFromKeywords, []);
  const DEFAULT_CATEGORY_SLUGS = [
  "restaurants",
  "repair-services",
  "beauty-spa",
  "physiotherapy",
  "real-estate",
  "wedding-planning",
];

const DEFAULT_SUGGESTIONS = DEFAULT_CATEGORY_SLUGS
  .map(slug => {
    const item = CATEGORY_INTENT_INDEX.find(i => i.slug === slug);
    return item
      ? { slug: item.slug, label: item.label }
      : null;
  })
  .filter(Boolean);



  // Handle search submission
  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();

      if (!searchQuery.trim()) return;

      const matchedCategory =
        activeSuggestionIndex >= 0 && suggestions[activeSuggestionIndex]
          ? suggestions[activeSuggestionIndex].slug
          : detectCategory(searchQuery);
      const searchUrl = `/category/${matchedCategory}?q=${encodeURIComponent(
        searchQuery
      )}`;

      history.push(searchUrl);
      setShowSuggestions(false);
      setActiveSuggestionIndex(-1);
    },
    [
      activeSuggestionIndex,
      detectCategory,
      history,
      searchQuery,
      suggestions,
      setShowSuggestions,
      setActiveSuggestionIndex,
    ]
  );

const handleSearchInputChange = useCallback(
  (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (!value.trim()) {
      setSuggestions(DEFAULT_SUGGESTIONS);
      setShowSuggestions(true);
      setActiveSuggestionIndex(-1);
      return;
    }

    const nextSuggestions = buildSuggestions(value);
    setSuggestions(nextSuggestions);
    setShowSuggestions(nextSuggestions.length > 0);
    setActiveSuggestionIndex(-1);
  },
  [buildSuggestions]
);


  const handleSearchKeyDown = useCallback(
    (e) => {
      if (!showSuggestions || suggestions.length === 0) {
        if (e.key === "Enter") handleSearch(e);
        return;
      }

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveSuggestionIndex((prev) => {
          const next = prev + 1;
          return next >= suggestions.length ? 0 : next;
        });
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveSuggestionIndex((prev) => {
          const next = prev - 1;
          return next < 0 ? suggestions.length - 1 : next;
        });
        return;
      }

      if (e.key === "Escape") {
        setShowSuggestions(false);
        setActiveSuggestionIndex(-1);
        return;
      }

      if (e.key === "Enter") {
        handleSearch(e);
      }
    },
    [handleSearch, showSuggestions, suggestions]
  );

const handleSuggestionClick = useCallback(
  (slug) => {
    const query = searchQuery.trim();

    const searchUrl = query
      ? `/category/${slug}?q=${encodeURIComponent(query)}`
      : `/category/${slug}`;

    history.push(searchUrl);
    setShowSuggestions(false);
    setActiveSuggestionIndex(-1);
  },
  [history, searchQuery]
);


const handleSearchFocus = useCallback(() => {
  if (!searchQuery.trim()) {
    setSuggestions(DEFAULT_SUGGESTIONS);
    setShowSuggestions(true);
    setActiveSuggestionIndex(-1);
    return;
  }

  const nextSuggestions = buildSuggestions(searchQuery);
  setSuggestions(nextSuggestions);
  setShowSuggestions(nextSuggestions.length > 0);
}, [buildSuggestions, searchQuery]);


  const handleSearchBlur = useCallback(() => {
    setTimeout(() => {
      setShowSuggestions(false);
      setActiveSuggestionIndex(-1);
    }, 120);
  }, []);

  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      const text = `Name: ${name}%0AMessage: ${message}`;
      window.open(`https://wa.me/919967956503?text=${text}`, "_blank");
    },
    [message, name]
  );

  // Add URLs for each category
  const categories = DASHBOARD_CATEGORIES;

  // Add this near your categories array
  const serviceCards = SERVICE_CARDS_LOOP;

  const handleCitySelect = useCallback((city) => {
    setSelectedCity(city);
    if (city === "Detect Location") {
      if (navigator.geolocation) {
        setSelectedCity("Detecting...");
        navigator.geolocation.getCurrentPosition(
          () => {
            setTimeout(() => {
              setSelectedCity("Vadodara");
            }, 1200);
          },
          (error) => {
            console.error("Error getting location:", error);
            setSelectedCity("Vadodara");
          }
        );
      }
    }
  }, []);

  // ✅ Handle clicking the search icon (mobile or desktop)
const handleSearchIconClick = useCallback(() => {
  if (!searchQuery.trim()) return;
  handleSearch(new Event("submit")); // Reuse same logic
}, [handleSearch, searchQuery]);


  const toggleCityDropdown = useCallback(() => {
    setShowCityDropdown((prev) => !prev);
  }, []);

  // Coming Soon state
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonCategory, setComingSoonCategory] = useState("");
  
  // Desktop Categories Show More state
  // const [showMoreCategories, setShowMoreCategories] = useState(false);

  const handleCategoryClick = useCallback((e, item) => {
    if (!item.enabled) {
      e.preventDefault();
      setComingSoonCategory(item.name);
      setShowComingSoon(true);
    }
  }, []);

  const handleServiceClick = useCallback((e, card) => {
    if (!card.enabled) {
      e.preventDefault();
      setComingSoonCategory(card.alt);
      setShowComingSoon(true);
    }
  }, []);

  return (
    <div className="biz-wrapper">
      {/* <Header /> */}

      <div className="biz-page">
        <div className="biz-container">
          {/* Premium Search Section */}
          <section className="premium-search-section">
            <div className="search-container">
              {/* Title with Gradient */}
              <div className="search-header-row">
                <div className="search-header">
                  <h1 className="gradient-title">
  Discover Trusted{" "}
  <span className="rotating-wrapper">
    <span className="rotating-track">
      <span className="rotating-item">Local Businesses  Near You</span>
      <span className="rotating-item">Repair & Services Near You</span>
      <span className="rotating-item">Restaurants Near You</span>
      <span className="rotating-item">Spa & Beauty Near You</span>
    </span>
  </span>
 
</h1>
                  {/* <p className="search-subtitle">
                    Find trusted services, compare ratings & get the best deals
                  </p> */}
                </div>

                {/* <div className="title-actions">
                 <a href="/business-listing"> <button className="my-business-btn">My Business</button></a>
                  <button className="get-leads-btn" onClick={() => setOpen(true)}>
  Get Leads
</button>
                </div> */}
              </div>
              {open && (
                <div className="popup-overlay">
                  <div className="popup-box">

                    {/* Close Button (Top Right) */}
                    <button
                      className="popup-close-btn"
                      onClick={() => setOpen(false)}
                      type="button"
                    >
                      ✕
                    </button>

                    <h3>Get Leads</h3>

                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        placeholder="Your Name"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />

                      <textarea
                        placeholder="Your Requirement"
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>

                      <button type="submit">Submit</button>
                    </form>
                  </div>
                </div>
              )}
              {/* Premium Search Box */}
              <div className="premium-search-box">
                <div className="search-input-group">
                  {/* Location with dropdown indicator */}
                  <div className="location-selector-container">
                    <div
                      className={`location-selector ${showCityDropdown ? "active" : ""}`}
                      onClick={toggleCityDropdown}
                    >
                      <i className="ri-map-pin-2-line"></i>
                      <div className="location-info">
                        <span className="location-label">Location</span>
                        <span className="location-value">{selectedCity}</span>
                      </div>
                      <i className="ri-arrow-down-s-line dropdown-icon"></i>
                    </div>

                    <CitySelector
                      isOpen={showCityDropdown}
                      onClose={() => setShowCityDropdown(false)}
                      onCitySelect={handleCitySelect}
                    />
                  </div>

                  {/* Divider */}
                  <div className="vertical-divider"></div>

                  {/* Main Search Input */}
                  <div className="main-search">
                 <div className="search-icon-wrap" onClick={handleSearchIconClick}>
  <i className="ri-search-line active-icon"></i>
</div>


                    <input
                      type="text"
                      placeholder="Search for Pest Control Services, Restaurants, Hotels..."
                      className="search-input"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                      onKeyDown={handleSearchKeyDown}
                      onFocus={handleSearchFocus}
                      onBlur={handleSearchBlur}
                    />

                    {showSuggestions && suggestions.length > 0 && (
                      <div className="search-suggestions" role="listbox">
                        {suggestions.map((s, idx) => (
                          <button
                            key={s.slug}
                            type="button"
                            className={`search-suggestion-item ${idx === activeSuggestionIndex ? 'active' : ''}`}
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => handleSuggestionClick(s.slug)}
                            role="option"
                            aria-selected={idx === activeSuggestionIndex}
                          >
                            <div className="search-suggestion-title">{s.label}</div>
                            <div className="search-suggestion-subtitle">
                              Search in {s.label}
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    <div className="search-actions">
                      <button className="voice-search">
                        {/* <i className="ri-mic-line"></i> */}
                      </button>
                      {/* <div className="shortcut-badges">
                       <a href="/category/education"> <span className="shortcut-badge">Pre school</span></a>
                        <a href="/category/beauty-spa"> <span className="shortcut-badge">Beauty spa</span></a>
                        <a href="/category/wedding-planning"> <span className="shortcut-badge">Wedding Planning</span></a>
                      </div> */}
                    </div>
                  </div>

                  {/* Search Button */}
                  <button className="premium-search-btn" onClick={handleSearchIconClick}>
  <i className="ri-search-line active-icon"></i>
  Search
</button>

                </div>

                {/* Quick Filters */}
                {/* <div className="quick-filters">
                  <span className="filter-label">Popular: </span>
                  <a href="/category/restaurants"><button className="filter-btn">Restaurants near me</button></a>
     
                  <a href="/category/repair-services"><button className="filter-btn">Emergency Repair</button></a>

                </div> */}
              </div>
            </div>
          </section>



          {/* Hero Section */}
          <div className="biz-hero">
            {/* LEFT AUTO SLIDER */}
            <div className="biz-service-slider">
  <div className="biz-service-track horizontal-scroll">

                {serviceCards.map((card, index) => (
                  <Link
                    to={card.enabled ? card.url : "#"}
                    key={index}
                    className="biz-service-card-link"
                    onClick={(e) => handleServiceClick(e, card)}
                  >
                    <div className="biz-service-card">
                      <img src={card.img} alt={card.alt} />
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* RIGHT BANNER */}
            <div className="biz-hero-main">
  {/* <video
    className="biz-hero-video"
    autoPlay
    muted
    loop
    playsInline
    preload="metadata"
  >
    <source src={bannerVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video> */}
  <img src ={banner1}></img>
</div>
 
             
             
  {/* CTA SECTION */}
  <div className="biz-hero-cta">
    <span>Best Deals. Trusted Businesses.</span>
    <button className="biz-hero-cta-btn">GET BEST DEALS</button>
  </div>

          </div>

          {/* Categories Section */}
          <div className="premium-categories-section">
            <div className="categories-header">
              <h2>Browse by Category</h2>
              <p>Find businesses across various industries</p>
            </div>

            <div className="categories-grid">
             {categories.slice(0, 12).map((item, index) => (
                  <a
                    href={item.enabled ? item.url : "#"}
                    className="category-card-link"
                    key={index}
                    onClick={(e) => handleCategoryClick(e, item)}
                  >
                    <div className="category-card">
                      <div className="category-icon-wrapper">
                        <img src={item.icon} alt={item.name} />
                        <div className="icon-hover-effect"></div>
                      </div>
                      <h3>{item.name}</h3>
                      <p className="category-count">New businesses added weekly</p>
                    </div>
                  </a>
                ))}
            </div>

            {/* Show More/Less Button - Desktop Only */}
          {categories.length > 8 && (
  <div className="show-more-container">
    <Link to="/all-categories" className="show-more-btn">
      Show More
      <span className="arrow-icon">→</span>
    </Link>
  </div>
)}

          </div>

          
<MobileCategoryGrid categories={DASHBOARD_CATEGORIES} />
          <Cities activeCity={selectedCity} />
        </div>
      </div>

      {/* Coming Soon Modal */}
      {showComingSoon && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button
              className="popup-close-btn"
              onClick={() => setShowComingSoon(false)}
              type="button"
            >
              ✕
            </button>

            <h3>Coming Soon</h3>
            <p style={{ marginBottom: '20px', color: '#64748b', fontSize: '15px' }}>
              <strong>{comingSoonCategory}</strong> will be available soon. We&apos;re working hard to bring you the best businesses in this category!
            </p>
            <button
              type="button"
              onClick={() => setShowComingSoon(false)}
              style={{
                width: '100%',
                background: 'linear-gradient(135deg, #1677ff, #722ed1)',
                color: 'white',
                border: 'none',
                padding: '14px',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      <Category2 />


      <Articles />
      {/* <HomeDiscoverySection /> */}
      {/* <Footer /> */}
    </div>
  );
}
Cities.propTypes = {
  activeCity: PropTypes.string,
};
